import { useEffect, useState } from "react";
import Swal from "sweetalert2";

import {
    Backdrop,
    Stack,
    TextField,
    Paper
} from "@mui/material";

import CustomButton from "../custom_components/CustomButton";
import CustomModalHeader from "../custom_components/CustomModalHeader";

export default function EditCustomer({
    open,
    onClose,
    info,
    onUpdate,
}) {

    const apiUrl = process.env.REACT_APP_API_URL;

    const [customerID, setCustomerID] = useState("");
    const [customerName, setCustomerName] = useState("");
    const [secondaryName, setSecondaryName] = useState("");
    const [fbLink, setFbLink] = useState("");

    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (open && info) {
            setCustomerID(info.CustomerID || "");
            setCustomerName(info.CustomerName || "");
            setSecondaryName(info.SecondName || "");
            setFbLink(info.FbLink || "");
        }
    }, [open, info]);


    const handleEdit = async () => {

        setIsSaving(true);

        try {

            const response = await fetch(`${apiUrl}manage_customer/customer_edit.php`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    customerID,
                    customerName,
                    secondaryName,
                    fbLink
                }),
            });

            const result = await response.json();

            if (result.status === "success") {

                Swal.fire({
                    icon: "success",
                    text: result.message || "",
                    timer: 1500,
                    showConfirmButton: false,
                });

                onUpdate({
                    id: info.id,
                    CustomerID: customerID,
                    CustomerName: customerName,
                    SecondName: secondaryName,
                    FbLink: fbLink
                });

                onClose();

            } else {

                Swal.fire({
                    text: result.message,
                    icon: "info"
                });
            }

        } catch (error) {

            Swal.fire({
                title: "Server Error!",
                text: error.message,
                icon: "error"
            });

        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Backdrop
            aria-hidden="false"
            open={open}
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                backdropFilter: "blur(1px)",
            }}
        >
            <Paper
                sx={{
                    width: 400,
                    p: 3,
                    borderRadius: 2,
                    position: "relative",
                    overflow: "hidden",

                    "&::before": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "4px",
                        background: "#2e3489"
                    }
                }}
            >

                {/* HEADER */}
                <CustomModalHeader
                    title="Edit Customer"
                    subtitle={`ID: ${customerID}`}
                    onClose={onClose}
                />

                {/* BODY */}
                <Stack spacing={2} mb={3}>
                    <TextField
                        fullWidth
                        size="small"
                        label="Customer Name"
                        value={customerName}
                        onChange={(e) =>
                            setCustomerName(e.target.value)
                        }
                    />

                    <TextField
                        fullWidth
                        size="small"
                        label="Secondary Name"
                        value={secondaryName}
                        onChange={(e) =>
                            setSecondaryName(e.target.value)
                        }
                    />

                    <TextField
                        fullWidth
                        size="small"
                        label="Facebook Link"
                        value={fbLink}
                        onChange={(e) =>
                            setFbLink(e.target.value)
                        }
                    />
                </Stack>

                {/* FOOTER */}
                <Stack
                    direction="row"
                    justifyContent="flex-end"
                    spacing={1.5}
                >
                    <CustomButton
                        label="Cancel"
                        variant="outlined"
                        hoverColor="#d14249"
                        onClick={onClose}
                    />

                    <CustomButton
                        label={isSaving ? "Saving..." : "Save Changes"}
                        disabled={isSaving}
                        onClick={handleEdit}
                    />
                </Stack>
            </Paper>

        </Backdrop>
    );
}